import { auth } from './auth.module';
import { requestHub } from './requestHub.module';
import { manualCardHub } from './manualCardHub.module';
import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
    modules: {
        auth,
        requestHub,
        manualCardHub
    }
})

export default store;